var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":"https://hypothes.is","target":"hypothes.is"}},[_vm._v("hypothes.is")])
}
var staticRenderFns = []

export { render, staticRenderFns }